module.exports = __webpack_public_path__ + "static/img/zhmmlogo.87877e40.png";